import { gql } from '@apollo/client';

export const invoicesListQuery = gql`
  query (
    $initialRow: Int
    $nextRows: Int
    $endIssueDate: String!
    $startIssueDate: String!
    $personId: Int!
    $invoiceTypeFilter: String!
  ) {
    InvoicesList(
      initialRow: $initialRow
      nextRows: $nextRows
      endIssueDate: $endIssueDate
      startIssueDate: $startIssueDate
      personId: $personId
      invoiceTypeFilter: $invoiceTypeFilter
    ) {
      alphaId
      branchId
      carrierName
      colorAbbreviation
      dueDate
      invoiceNote
      invoiceNumber
      invoiceOriginIssueDate
      invoiceOriginNumber
      issueDate
      itemQuantity
      itemSeq
      netValue
      numericCode
      operationTaxCode
      operationTaxName
      productDescription
      invoiceKeyCode
      providerDocumentId
      nrNfeServico
      productName
      purchaseOrderId
      qualityIndicator
      totalAmount
    }
    ExtremaCityHallSite {
      cityHallSite
      cityHallNfs
    }
  }
`;
